export default "/fonts/Urbanist-SemiBold.ttf?41afa9de7bd08ba718d85f8e861749bb";